/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

// Crashlytics no-op stub + Sentry user identification.
// The @capacitor-firebase/crashlytics package was removed due to Capacitor 8
// SPM compile errors. Re-enable after App Store approval by reinstalling the
// package and restoring the original implementation from git history.
//
// Existing call sites preserved (logCrash, setUserContext, recordException)
// so no imports break; the Crashlytics-specific ones silently no-op.
//
// setUserContext / clearUserContext additionally identify the user in Sentry so
// crash/error events can be attributed per-account. We attach ONLY the Firebase
// uid — never phone number, name, email, or location — so Sentry can distinguish
// "one user, 20 errors" from "20 users, 1 error each" without carrying PII.
import * as Sentry from "@sentry/react";

export async function logCrash(_message: string, _context?: Record<string, string>) {
  // no-op
}

export async function setUserContext(uid: string, _email?: string) {
  // Crashlytics native tagging: no-op until the package is re-enabled.
  // Sentry: attribute events to this account by uid only (no PII — see above).
  Sentry.setUser({ id: uid });
}

export function clearUserContext() {
  // Detach the user from subsequent Sentry events so a stale uid is never
  // attributed to a logged-out session (or the next account on this device).
  Sentry.setUser(null);
}

export async function recordException(_error: Error, _context?: string) {
  // no-op
}
